export default "__VITE_ASSET__Cpjp$OGh__"